<template>
  <button
    :class="clsNames"
    :type="nativeType"
    :disabled="disabled || loading"
    @click="emitClick"
    @mousedown="emitMousedown"
  >
    <template v-if="iconPlacement === 'left'">
      <cms-icon v-if="loading || slots.icon">
        <loading v-if="loading"></loading>
        <template v-else-if="slots.icon">
          <component :is="slots.icon"></component>
        </template>
      </cms-icon>
    </template>
    <slot></slot>
    <template v-if="iconPlacement === 'right'">
      <cms-icon v-if="loading || slots.icon">
        <loading v-if="loading"></loading>
        <template v-else-if="slots.icon">
          <component :is="slots.icon"></component>
        </template>
      </cms-icon>
    </template>
  </button>
</template>

<script setup lang="ts">
import Loading from '@chenms-demo/components/internal-icon/Loading'
import { createNamespace } from '@chenms-demo/utils/create'
import { buttonEmits, buttonProps, Size, Type } from './button'
import { computed, useSlots } from 'vue'

const bem = createNamespace('button')

const props = defineProps(buttonProps)
const emit = defineEmits(buttonEmits)
const slots: any = useSlots()
defineOptions({
  name: 'cms-button',
  // 不接收父组件额外传的属性
  inheritAttrs: false
})

const clsNames = computed(() => {
  return [
    ...new Set([
      bem.b(),
      bem.m(props.type),
      bem.m(props.size),
      bem.is('round', props.round),
      bem.is('loading', props.loading),
      bem.is('disabled', props.disabled)
    ])
  ]
})

const emitClick = (e: MouseEvent) => {
  emit('click', e)
}

const emitMousedown = (e: MouseEvent) => {
  emit('mousedown', e)
}
</script>

<style scoped></style>
